import {DatabaseCode, toDatabaseCode, toDatabaseCodeSafely} from "../database-code";

export type ServiceEventTargetMode = DatabaseCode;

const include: ServiceEventTargetMode = {
  code: "INCLUDE",
  displayValue: {
    id: "common.entity.serviceeventtargetmode.include",
    defaultMessage: "Include",
  },
};

const exclude: ServiceEventTargetMode = {
  code: "EXCLUDE",
  displayValue: {
    id: "common.entity.serviceeventtargetmode.exclude",
    defaultMessage: "Exclude",
  },
};

export const serviceEventTargetMode = {
  include,
  exclude,
};

export const serviceEventTargetModes: ServiceEventTargetMode[] = Object.values(serviceEventTargetMode);

export const toServiceEventTargetMode = (code: string): ServiceEventTargetMode =>
  toDatabaseCode(code, serviceEventTargetModes);

export const toServiceEventTargetModeSafely = (
  code: string | undefined,
  defaultValue: ServiceEventTargetMode | undefined = undefined
): ServiceEventTargetMode | undefined => toDatabaseCodeSafely(code, serviceEventTargetModes, defaultValue);
